import React, { useState, useEffect } from "react";

function Heading({ data }) {
  const [element, setElement] = useState({
    type: "subheading",
    properties: {
      title: "Sub Heading",
    },
  });

  useEffect(() => {
    setElement(data);
  }, [data]);

  return (
    <div
      className="form-builder-element col-md-12"
      data={JSON.stringify(element)}
    >
      <h4>{element.properties.title}</h4>
    </div>
  );
}

export default Heading;
